import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from 'components/LoadableLoading';

// Публичная страница: открывается без авторизации, см. PUBLIC_ROUTES в routes.tsx
export const path = '/privacy-policy';

const PagePrivacyPolicy: React.FC = () => {
  const Page = Loadable.Map({
    loader: {
      page: () => import('./page'),
    },
    loading: LoadableLoading,
    render(loaded) {
      const Component = loaded.page.default;

      return <Component />;
    },
  });

  return <Page />;
};

export default PagePrivacyPolicy;
